import classNames from "classnames";
import Styles from "./Service.module.scss";
import Navbar from "../../Component/Navbar/Navbar";
import SubTitle from "../../Component/Text/SubTitle";
import Footer from "../../Component/Footer/Footer";
import LINEImg from "../../assets/images/contact/LINE.png";

const BusReserved = () => {
  return (
    <div>
      <Navbar />
      <div style={{ padding: "8vh" }} className={classNames("container")}>
        <SubTitle text={`長期照顧長照巴士預約接送`} />
        <div className={classNames(Styles.service__item)}>
          <h5 className={classNames(Styles.service__item__title)}>
            交通接送服務
          </h5>
          <h6 className={classNames(Styles.service__item__subtitle)}>
            服務對象
          </h6>
          <p className={classNames(Styles.service__item__param)}>
            實際居住本縣，經本縣長期照顧管理中心評估核定，且符合以下資格之一(不適用於長照住宿式機構之服務使用者)：
          </p>
          <div className={classNames(Styles.service__item__list)}>
            <ul>
              <li>65歲以上失能老人</li>
              <li>55歲以上失能原住民</li>
              <li>50歲以上失智症者</li>
              <li>失能身心障礙者</li>
            </ul>
          </div>
          <h6 className={classNames(Styles.service__item__subtitle)}>
            服務項目{" "}
          </h6>
          <p className={classNames(Styles.service__item__param)}>
            提供服務對象往返居家至醫療院所就醫、定期式復健或透析治療之交通接送。
          </p>
          <h6 className={classNames(Styles.service__item__subtitle)}>
            費用補助類別{" "}
          </h6>
          <p className={classNames(Styles.service__item__param)}>
            (一)、 長期照顧交通接送服務(DA01)
          </p>
          <div className={classNames(Styles.service__item__list)}>
            <table className={classNames(Styles.service__table)}>
              <caption>長期照顧交通接送服務DA01價格表</caption>
              <thead>
                <tr>
                  <th colSpan="4">
                    長期照顧交通接送服務DA01 給（支）付價格（元）
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>給付額度</td>
                  <td colSpan="3">給付額度2,400元(最高8趟)/每趟300元</td>
                </tr>
                <tr>
                  <td>補助身分別</td>
                  <td>補助比例</td>
                  <td>補助金額</td>
                  <td>民眾自付額</td>
                </tr>
                <tr>
                  <td>低收入戶</td>
                  <td>100 %</td>
                  <td>300 元</td>
                  <td>0 元</td>
                </tr>
                <tr>
                  <td>中低收入戶</td>
                  <td>93 %</td>
                  <td>279 元</td>
                  <td>21 元</td>
                </tr>
                <tr>
                  <td>一般戶</td>
                  <td>79 %</td>
                  <td>237 元</td>
                  <td>63 元</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className={classNames(Styles.service__item__list)}>
            <ul>
              <li>超過核定8趟次的交通服務需求，依照本會收費標準全額自費。</li>
              <li>自費收費方式以花蓮縣公告計程車費率計，(跳表)100元起跳。</li>
              <li>自費共乘雙方：給予6折優待 (跳表)60元起跳。</li>
              <li>陪同者：第1位不收費，第2位酌收50元，以二人為限。</li>
              <li>未按時搭乘爽約(空跑)每趟收取服務費用100元。</li>
            </ul>
          </div>
          <p className={classNames(Styles.service__item__param)}>
            (二)、 社區長照交通接送服務(BD03)：
          </p>
          <div className={classNames(Styles.service__item__list)}>
            <table className={classNames(Styles.service__table)}>
              <caption>社區式交通接送服務BD03價格表</caption>
              <thead>
                <tr>
                  <th colSpan="4">
                    社區式交通接送服務BD03 給（支）付價格（元）
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>給付額度</td>
                  <td colSpan="3">每趟100元</td>
                </tr>
                <tr>
                  <td>補助身分別</td>
                  <td>補助比例</td>
                  <td>補助金額</td>
                  <td>民眾自付額</td>
                </tr>
                <tr>
                  <td>低收入戶</td>
                  <td>100%</td>
                  <td>100元</td>
                  <td>0元</td>
                </tr>
                <tr>
                  <td>中低收入戶</td>
                  <td>93%</td>
                  <td>95元</td>
                  <td>5元</td>
                </tr>
                <tr>
                  <td>一般戶</td>
                  <td>79%</td>
                  <td>84元</td>
                  <td>16元</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className={classNames(Styles.service__item__list)}>
            <ul>
              <li>
                經花蓮縣長期照顧管理中心評估，依核定身分別收費。
                <br />
                本組合以長照給付對象住家與社區式服務類長照機構之距離十公里以內者，
                <br />
                適用本組合，超過十公里所需費用由長照給付對象自行負擔。
                <br />
                十公里內收費標準請參照【社區式交通接送服務BD03價格表】。
              </li>

              <li>
                超過十公里收費標準：
                <br />
                0至2公里以24元計收、2公里以上至4公里以48元計收;
                <br />
                4公里以上至6公里以72元計收、6公里以上至8公里以96元計收;
                <br />
                8公里以上至10公里以120元計收，以此類推。
                <br />
              </li>
              <li>超過核定給付額度：每趟以實際跳表費用計收。</li>
              <li>未按時搭乘爽約(空跑)每趟收取服務費用100元。</li>
              <li>陪同者：陪同者酌收50元，以一人為限。</li>
            </ul>
          </div>

          <h6 className={classNames(Styles.service__item__subtitle)}>
            申請窗口
          </h6>
          <div className={classNames(Styles.service__item__list)}>
            <ul>
              <li> 預約時間週一至週五：上午08:00-12:00、下午13:00-1700</li>
              <li>電話預約：03-8530099</li>
              <li>預約ID：@336wnpqq</li>
            </ul>
          </div>
          <div className={classNames(Styles.service__item__list)}>
            <img
              style={{ maxWidth: "30vh" }}
              src={LINEImg}
              alt="LINE.png"
            ></img>
          </div>
          <h6 className={classNames(Styles.service__item__subtitle)}>
            服務時間
          </h6>
          <div className={classNames(Styles.service__item__list)}>
            <ul>
              <li>週一至週五 上午8時至下午17時30分</li>
              <li>上午8時可抵達乘客預約上車地點。</li>
              <li>下午5時可抵達乘客預約上車地點。</li>
            </ul>
          </div>
          <span
            style={{
              color: "red",
              letterSpacing: "0.2vh",
              lineHeight: "5vh",
              fontSize: "2.5vh",
            }}
          >
            ※政府機關所公告因天災或人禍的停班，基於安全考量，將暫時提供服務※
          </span>
        </div>
      </div>
      <div>
        <Footer />
      </div>
    </div>
  );
};

export default BusReserved;
